let UtilsScroll: typeof import('@/core/utils/scroll');

/**
 * Добавить отображение тени при появлении скролла у элемента
 *
 * Будут добавлены события для усатновки модификаторов тени в зависимости от скролла элемента
 *
 * Модификаторы:
 * - top-scrollShadow
 * - top-scrollShadow-started
 * - top-scrollShadow-finished
 */
const connectScrollShadow = {
	async mounted(el) {
		if (!UtilsScroll) UtilsScroll = await import('@/core/utils/scroll');

		UtilsScroll.connectScrollShadow(el);
	},

	async unmounted(el) {
		if (!UtilsScroll) UtilsScroll = await import('@/core/utils/scroll');

		UtilsScroll.unconnectScrollShadow(el);
	},
};

export default connectScrollShadow;
